define('AwaLabs.ProductReviewsRemoval', [
], function AwaLabsProductReviewsRemoval(
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var pdp = container.getComponent('PDP');
            var environment = container.getComponent('Environment');
            var config = environment.getConfig('productReviewsRemoval');
            var remove = config && config.enable;

            if (layout && remove) {
                layout.removeChildView('GlobalViews.StarRating');
                layout.removeChildView('Global.StarRating');
            }

            if (pdp && remove) {
                pdp.removeChildView(pdp.PDP_FULL_VIEW, 'ProductReviews.Center', 'ProductReviews.Center');
                pdp.removeChildView(pdp.PDP_FULL_VIEW, 'Global.StarRating', 'Global.StarRating');
            }
        }
    };
});
